import React, {  } from 'react';
import { Col, ToggleButtonGroup, ToggleButton, Form } from 'react-bootstrap';


interface Props {
    value?: any;
    atualizarFiltro?: (value: string) => void;

}

const ValueComponent: React.FC<Props> = (props) => {

    return (
        <Form.Group as={Col} className="mb-2 valueComponent">
            <Form.Label className="font-size-14 form-label mb-0">Value</Form.Label>
            <Col md={12}>
                <ToggleButtonGroup
                    value={props.value}
                    type="radio"
                    name="options1"
                    className="w-100"
                    onChange={(value) => {
                        // if (value) {
                        //     props.value = value;
                        // }
                        if (props.atualizarFiltro) {
                            props.atualizarFiltro(value);
                        }
                    }}
                >
                    <ToggleButton id="tbg-value-1" variant="outline-primary" value={"Quantity"} className="w-50">
                        Quantity
                    </ToggleButton>
                    <ToggleButton id="tbg-value-2" variant="outline-primary" value={"Revenue"} className="w-50">
                        Revenue
                    </ToggleButton>
                </ToggleButtonGroup>
            </Col>
        </Form.Group>
    );
};

export default ValueComponent;
